/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AlertTriangle,
  ArrowRight,
  Award,
  BarChartIcon,
  Calendar,
  CheckCircle,
  Code2,
  Eye,
  Flame,
  Goal,
  HeartIcon,
  Hourglass,
  IndianRupee,
  LockKeyhole,
  MessageCircle,
  Radio,
  Repeat2,
  Search,
  TrendingUp,
  Trophy,
  Wrench,
} from "lucide-react";
import { BiSync } from "react-icons/bi";

import { cn } from "@/lib/utils";
import { dateTimeFormat, isMoreThanXDays } from "@/Helpers/times-ago";
import { isDevice } from "@/Helpers/helper";

import {
  ExtensionCheckDialog,
  InstallExtensionDialogContainer,
} from "@/Pages/Influencer/CreateProfileV1/SyncLinkedinWithExt";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { BrandCollabSection } from "../../../BrandCollabs/BrandCollabs";
import {
  CollabCard,
  InfluencerProfileStrength,
  InfluencerWhatsappGroupCard,
  NoCollabErrorMessage,
} from "../DashboardMolecules";
import { LiveAnchorsCollabSkeleton, CollabStatusChip } from "../DashboardAtoms";
import { useEffect, useRef, useState } from "react";
import { useStaticData } from "@/Providers/Data";
import { useInfluencer } from "@/Providers/Influencer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";
import { StackAvatars } from "@/Pages/Influencer/LocationChapters/Components/molecules";
import { FaRegShareSquare } from "react-icons/fa";
import { GradientImage } from "@/Pages/Influencer/LocationChapters/Components/atoms";
import {
  getRemainingTimeForCollab,
  getTimeLabelForCollab,
} from "../../../BrandCollabs/BrandCollabHelpers";
import { useAuth } from "../../../../../../Providers/Auth";

const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const LiveAnchorsCollabs = ({
  showErrorMessage = false,
  currentFilter,
  className,
}: {
  showErrorMessage?: boolean;
  currentFilter?: BrandCollabSection;
  className?: string;
}) => {
  const influencerState = useInfluencer();
  const navigate = useNavigate();
  const staticDataState = useStaticData();

  // get all anchor collabs ----------------
  const [allAnchorCollabs, setAllAnchorCollabs] = useState<any[]>([]);
  const [collabLoading, setCollabLoading] = useState(false);
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);

  const getAllAnchorsCollab = async () => {
    try {
      setCollabLoading(true);
      const response = await influencerState.getAllAnchorsCollab();
      if (response?.success) {
        setAllAnchorCollabs(response?.collabs);
      } else {
        setAllAnchorCollabs([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setCollabLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    getAllAnchorsCollab();
  }, []);

  const [openExtInstall, setOpenExtInstall] = useState(false);
  const [extTargetUrl, setExtTargetUrl] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    setIsMobile(isDevice().mobile);
  }, []);

  const [loadingTracking, setLoadingTracking] = useState(false);

  const handleTrackPost = async ({ anchorsCollabId, postUrl, collabId }) => {
    try {
      setLoadingTracking(true);
      const response = await axios.get(
        `${host}/collab/brand/getPostTracking/?collabId=${collabId}&postUrl=${postUrl}&anchorsCollabId=${anchorsCollabId}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        getAllAnchorsCollab();

        // toast({
        //   title: `Post Tracking refreshed successfully`,
        // });
      }
    } catch (e) {
      return { Error: e.response.data.error };
    } finally {
      setLoadingTracking(false);
    }
  };

  const getCollabStatus = (collab) => {
    if (collab?.response) {
      const response = collab?.response?.toUpperCase();

      if (
        response === "ACCEPTED" &&
        collab?.trackingLink &&
        collab?.brandApproval &&
        !collab?.isExpired &&
        isMoreThanXDays(collab?.liveAt, 3)
      ) {
        return "COMPLETED";
      } else if (
        response === "ACCEPTED" &&
        collab?.trackingLink &&
        collab?.brandApproval &&
        !collab?.isExpired
      ) {
        return "LIVE";
      } else if (response === "ACCEPTED" && !collab.isExpired) {
        return "ACCEPTED";
      } else if (response === "PENDING" && !collab.isExpired) {
        return "NEW";
      }
    }
  };
  const getFilteredCollabs = (
    status: "COMPLETED" | "LIVE" | "ACCEPTED" | "NEW"
  ) => {
    if (
      (currentFilter === "New" && status === "NEW") ||
      (currentFilter === "Ongoing" && status === "ACCEPTED") ||
      (currentFilter === "Ongoing" && status === "LIVE") ||
      (currentFilter === "Completed" && status === "COMPLETED")
    ) {
      showErrorMessage = false;
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {openExtInstall && (
        <ExtensionCheckDialog
          open={openExtInstall}
          onOpenChange={setOpenExtInstall}
          content={
            <InstallExtensionDialogContainer
              reSync={true}
              redirectUrl={`${window.localStorage.origin}/influencer/plugin/callback}`}
              extTargetUrl={extTargetUrl}
              closeCurrentWindow={true}
              open={openExtInstall}
            />
          }
        />
      )}
      {collabLoading && (
        <div className="">
          <LiveAnchorsCollabSkeleton />
        </div>
      )}
      {!collabLoading && allAnchorCollabs?.length > 0 && (
        <div className={cn("text-white space-y-4", className)}>
          <div className="flex flex-col gap-4">
            {allAnchorCollabs?.map((collab, index) => {
              if (collab?.isExpired) return null;
              let bottomSectionDataArray: CollabCardProps["bottomSectionDataArray"] =
                [];
              let actionButton = <></>;
              const status = getCollabStatus(collab);
              if (status === "NEW" || status === "ACCEPTED") {
                actionButton = (
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      mixpanel.track(
                        `Influencer Dashboard Page : ${
                          !collab?.isExpired ? "View Details" : "Expired"
                        } - Clicked`
                      );
                      {
                        !collab?.isExpired
                          ? navigate(
                              `/influencer/brandCollabs/details/?key=${
                                collab?.collabId
                              }&section=${
                                collab?.brandApproval === "accepted"
                                  ? 4
                                  : collab?.response?.toUpperCase() ===
                                    "ACCEPTED"
                                  ? 2
                                  : 1
                              }`
                            )
                          : "";
                      }
                    }}
                  >
                    View Details
                    <ArrowRight size={16} className="ml-1" />
                  </Button>
                );
                bottomSectionDataArray = [
                  {
                    icon: <IndianRupee color="#1070E0" size={25} />,
                    title:
                      collab?.campaignInfo?.collabType === "fixed"
                        ? "Earnings"
                        : "Earn Approx",
                    value:
                      collab?.campaignInfo?.collabType === "fixed"
                        ? "₹" +
                          new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(collab?.approxPrice)
                        : "₹" +
                          new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(collab?.minApproxPrice) +
                          "-" +
                          "₹" +
                          new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(collab?.approxPrice),
                  },
                  {
                    icon: <Goal color="#DC2627" size={25} />,
                    title: "Campaign Goal",
                    value: `${
                      collab?.collabInfo?.collabPurpose
                        ?.map((purpose, index) =>
                          index < collab?.collabInfo?.collabPurpose?.length - 1
                            ? masterCollabGoals?.find(
                                (goal) => goal?._id === purpose
                              )?.CollabGoalsName + ", "
                            : masterCollabGoals?.find(
                                (goal) => goal?._id === purpose
                              )?.CollabGoalsName
                        )?.[0]
                        ?.replace(/,/g, "") || "-"
                    }`,
                    tooltip: {
                      content: collab?.collabInfo?.collabPurpose?.map(
                        (purpose, index) =>
                          index < collab?.collabInfo?.collabPurpose?.length - 1
                            ? masterCollabGoals?.find(
                                (goal) => goal?._id === purpose
                              )?.CollabGoalsName + ", "
                            : masterCollabGoals?.find(
                                (goal) => goal?._id === purpose
                              )?.CollabGoalsName
                      ),
                    },
                  },
                  {
                    icon: <Calendar color="#1070E0" size={25} />,
                    title: "Campaign Duration",
                    value: `${5} Days`,
                    tooltip: {
                      content: `
                          ${new Date(collab?.campaignInfo?.campaignStartDate)}
                        `,
                    },
                  },
                  {
                    icon: <Hourglass color="#13931D" size={25} />,
                    title: `${getTimeLabelForCollab(collab)}`,
                    value: `${getRemainingTimeForCollab(collab)}`,
                  },
                ];
              } else if (status === "LIVE" || status === "COMPLETED") {
                actionButton = (
                  <>
                    {collab?.trackingLink?.includes("linkedin.com/posts/") ||
                    collab?.trackingLink?.includes(
                      "linkedin.com/feed/update/"
                    ) ? (
                      <div className="flex w-full flex-col gap-2.5 ">
                        <span
                          onClick={() =>
                            navigate(
                              `/influencer/brandCollabs/details/?key=${collab?.collabId}&section=4`
                            )
                          }
                          className="cursor-pointer flex gap-2.5 justify-center items-center text-[#DC2627] text-sm not-italic font-medium leading-6 "
                        >
                          View Details <ArrowRight size={16} />{" "}
                        </span>
                        <Button
                          disabled={loadingTracking || window.innerWidth < 600}
                          variant="destructive"
                          className="w-full"
                          size="sm"
                          onClick={() => {
                            mixpanel.track("Sync Collab Data - Clicked");

                            // server side scraping
                            handleTrackPost({
                              anchorsCollabId: collab?._id,
                              collabId: collab?.collabId,
                              postUrl: collab?.trackingLink,
                            });

                            //client side scraping
                            if (isMobile) {
                              toast({
                                title: "Please switch to a desktop to sync",
                                variant: "destructive",
                              });
                              return;
                            } else {
                              setOpenExtInstall(true);
                              const postlink =
                                collab?.trackingLink?.split("?")?.[0];
                              setExtTargetUrl(
                                postlink +
                                  "?ref=anchors&page=singlePost&collabId=" +
                                  collab?.collabId
                              );
                            }
                          }}
                        >
                          <BiSync
                            size={16}
                            className={cn(
                              "mr-1",
                              loadingTracking ? "animate-spin" : ""
                            )}
                          />
                          <p className="flex flex-col items-center justify-center">
                            Sync Collab Data
                          </p>
                        </Button>
                        {window.innerWidth < 600 && (
                          <p className="text-xs text-gray-500">
                            (Note: Synchronization is available only on the
                            desktop)
                          </p>
                        )}
                      </div>
                    ) : (
                      <span className="text-xs text-red-500">
                        ⚠️ Invalid linkedIn post link
                      </span>
                    )}
                  </>
                );
                bottomSectionDataArray = [
                  {
                    icon: <Eye color="#1070E0" size={25} />,
                    title: "Impressions",
                    value: collab?.postTracking?.impressions,
                  },
                  {
                    icon: <HeartIcon color="#DC2627" size={25} />,
                    title: "Likes",
                    value: collab?.postTracking?.likes,
                  },
                  {
                    icon: <MessageCircle color="#1070E0" size={25} />,
                    title: "Comments",
                    value: collab?.postTracking?.comments,
                  },
                  {
                    icon: <Repeat2 color="#13931D" size={25} />,
                    title: "Reposts",
                    value: collab?.postTracking?.reposts,
                  },
                ];
              }

              return (
                (currentFilter ? getFilteredCollabs(status) : true) && (
                  <CollabCard
                    key={index}
                    brandName={collab?.brandName}
                    brandWebsiteLink={collab?.brandWebsite}
                    actionButton={actionButton}
                    lastSyncedTimeStamp={
                      {
                        COMPLETED:
                          collab?.postTracking?.updatedAt &&
                          dateTimeFormat(collab?.postTracking?.updatedAt),
                        LIVE:
                          collab?.postTracking?.updatedAt &&
                          dateTimeFormat(collab?.postTracking?.updatedAt),
                      }[status]
                    }
                    statusChip={
                      {
                        NEW: (
                          <CollabStatusChip
                            statusText="New Brand Collab"
                            icon={<Flame size={16} color="#FF6242" />}
                            textColor="text-[#FF6242]"
                            bgColor="bg-[#000000]"
                          />
                        ),
                        ACCEPTED: (
                          <CollabStatusChip
                            statusText="Accepted Collab"
                            icon={<CheckCircle size={16} color="#9AFFB4" />}
                            textColor="text-[#9AFFB4]"
                            bgColor="bg-[#000000]"
                          />
                        ),
                        LIVE: (
                          <CollabStatusChip
                            statusText="Live Collab"
                            bgColor="bg-[#490000]"
                            textColor="text-[#FFA2A2]"
                            icon={<Radio size={16} color="#FFA2A2" />}
                          />
                        ),
                        COMPLETED: (
                          <CollabStatusChip
                            statusText="COMPLETED Collab"
                            bgColor="bg-[#490000]"
                            textColor="text-[#FFA2A2]"
                            icon={<Radio size={16} color="#FFA2A2" />}
                          />
                        ),
                      }[status]
                    }
                    collabTypeChip={
                      {
                        fixed: (
                          <CollabStatusChip
                            statusText="Fixed payment"
                            icon={<LockKeyhole size={16} color="#9AFFB4" />}
                            textColor="text-[#9AFFB4]"
                            bgColor="bg-[#000000]"
                          />
                        ),
                        performance: (
                          <CollabStatusChip
                            statusText="Performance based payment"
                            icon={<TrendingUp size={16} color="#9AFFB4" />}
                            textColor="text-[#9AFFB4]"
                            bgColor="bg-[#000000]"
                            info={`Expected ${parseInt(
                              collab?.minImpressions
                            )?.toLocaleString()} - ${parseInt(
                              collab?.maxImpressions
                            )?.toLocaleString()} impressions`}
                          />
                        ),
                      }[collab?.campaignInfo?.collabType]
                    }
                    bottomSectionDataArray={bottomSectionDataArray}
                    collabId={collab?.collabId}
                    ratingGiven={collab?.Rating}
                    status={status}
                    postTracking={collab?.postTracking}
                  />
                )
              );
            })}
          </div>
        </div>
      )}
      {!collabLoading && showErrorMessage && (
        <NoCollabErrorMessage className="mt-20 " />
      )}
    </>
  );
};

export const InfluencerWAAndProfileStrength = ({
  isProfileActive,
  currentProfileStrength,
}: {
  isProfileActive: boolean;
  currentProfileStrength: number;
}) => {
  return (
    <>
      <div className="flex gap-5 justify-center flex-col md:flex-row">
        <InfluencerWhatsappGroupCard isProfileActive={isProfileActive} />
        <InfluencerProfileStrength
          currentProfileStrength={currentProfileStrength}
        />
      </div>
    </>
  );
};

export const InfluencerDashboardChapterCard = () => {
  // Chapter Details ---------------------
  interface ChapterDetails {
    chapterDetails?: {
      chapterName?: string;
      chapterId?: string;
      pageDesc?: string;
      shortDesc?: string;
      cover?: string;
      logo?: string;
      title?: string;
      slug?: string;
      city?: string;
    };
    joinedCreators?: {
      count?: number;
      avatars?: string[];
    };
  }

  const [chapterDetails, setChapterDetails] = useState<ChapterDetails>();

  useEffect(() => {
    const fetchInfluencerChapterDetails = async () => {
      try {
        const res = await axios.get(`${host}/influencer/getChapterDetails`, {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        });
        if (res?.data?.success) {
          setChapterDetails(res?.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchInfluencerChapterDetails();
  }, []);

  const handleClickDetails = () => {
    window.open(
      `${window.location.origin}/chapter/${chapterDetails?.chapterDetails?.slug}`,
      "_blank"
    );
  };

  const handleShare = () => {
    const message = `I've joined this Chapter; it's for creators living in ${chapterDetails?.chapterDetails?.city} only. If you're in ${chapterDetails?.chapterDetails?.city} too, do join, so we can all find each other and plan something exciting for some weekend! :D  ${window.location.origin}/chapter/${chapterDetails?.chapterDetails?.slug}`;
    navigator.clipboard.writeText(message);
    navigator.share({
      text: message, //chapter description
    });
  };

  // console.log(chapterDetails);

  return (
    <>
      {chapterDetails?.chapterDetails?.chapterId && (
        <>
          <div className="hidden md:flex items-start gap-5 self-stretch">
            <div className="flex flex-col items-start gap-3 flex-[1_0_0] self-stretch bg-[linear-gradient(0deg,rgba(110,0,250,0.07)_0%,rgba(220,38,39,0.12)_100%)] p-5 rounded-[10px]">
              <div className="flex justify-center items-start gap-1 rounded border bg-[rgba(38,220,44,0.16)] px-2 py-1 border-solid border-[rgba(38,220,44,0.16)] text-[color:var(--Shade-White,#FFF)] text-center text-[10px] not-italic font-normal leading-[normal] uppercase ">
                YOU ARE A PART OF{" "}
                <span className="font-bold">
                  {chapterDetails?.chapterDetails?.chapterName}
                </span>
              </div>
              <div className="flex items-start gap-[30px]">
                <div className="w-[118.904px] h-[140px] rounded-[10px] overflow-hidden ">
                  <img
                    className="w-full h-full rounded-sm "
                    src={chapterDetails?.chapterDetails?.logo}
                    alt="chapterImage"
                  />
                </div>
                <div className="flex flex-col items-start gap-3.5">
                  <div className="flex w-[422px] flex-col items-start gap-3">
                    <span className="text-[color:var(--Shade-White,#FFF)] text-center text-base not-italic font-bold leading-5">
                      {chapterDetails?.chapterDetails?.title}
                    </span>
                    <span className="text-[#ADADAD] text-xs not-italic font-normal leading-5">
                      {chapterDetails?.chapterDetails?.pageDesc}
                    </span>
                  </div>
                  <div className="ml-3">
                    {chapterDetails?.joinedCreators?.avatars?.length > 0 && (
                      <StackAvatars
                        avatarUrls={chapterDetails?.joinedCreators?.avatars}
                        totalCount={chapterDetails?.joinedCreators?.count}
                        variant="default"
                        viewLimit={3}
                      />
                    )}
                  </div>

                  <div className="flex items-start gap-5 self-stretch">
                    <Button
                      onClick={handleClickDetails}
                      className="gap-3 bg-[#DC2627] "
                      variant="destructive"
                    >
                      View Chapter Details <ArrowRight size={16} />
                    </Button>
                    <Button
                      onClick={handleShare}
                      className="gap-3 bg-[#FFFFFF] "
                      variant="secondary"
                    >
                      Share with Creators <FaRegShareSquare size={16} />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex md:hidden min-h-[442px] !mb-[15px] ">
            <GradientImage
              image={chapterDetails?.chapterDetails?.cover}
              height={442}
              width={320}
              altText={"chapterImage"}
              className="rounded-sm w-full "
              footer={
                <div className="flex w-[272px] pb-[26px] flex-col items-start gap-[15px] ">
                  <div className="flex justify-center items-start gap-1 rounded border bg-[rgba(38,220,44,0.26)] px-2 py-1 border-solid border-[rgba(38,220,44,0.16)] text-[color:var(--Shade-White,#FFF)] text-center text-[10px] not-italic font-normal leading-[normal] uppercase ">
                    YOU ARE A PART OF{" "}
                    <span className="font-bold">
                      {chapterDetails?.chapterDetails?.chapterName}
                    </span>
                  </div>
                  <div className="flex  flex-col items-start gap-2">
                    <span className="text-[color:var(--Shade-White,#FFF)] text-center text-base not-italic font-bold leading-5">
                      {chapterDetails?.chapterDetails?.title}
                    </span>
                    <span className="text-[#ADADAD] text-xs not-italic font-normal leading-5">
                      {chapterDetails?.chapterDetails?.pageDesc}
                    </span>
                  </div>
                  <div className="ml-3">
                    {chapterDetails?.joinedCreators?.avatars?.length > 0 && (
                      <StackAvatars
                        avatarUrls={chapterDetails?.joinedCreators?.avatars}
                        totalCount={chapterDetails?.joinedCreators?.count}
                        variant="small"
                        viewLimit={3}
                      />
                    )}
                  </div>

                  <div className="flex items-start gap-3 self-stretch">
                    <Button
                      onClick={handleClickDetails}
                      className="gap-3 bg-[#DC2627] text-xs "
                      variant="destructive"
                    >
                      View Chapter Details <ArrowRight size={16} />
                    </Button>
                    <Button
                      onClick={handleShare}
                      className="gap-3 bg-[#FFFFFF] "
                      variant="secondary"
                    >
                      <FaRegShareSquare size={16} />
                    </Button>
                  </div>
                </div>
              }
            />
          </div>
        </>
      )}
    </>
  );
};

export const ActivateProfileCard = () => {
  const navigate = useNavigate();
  const authState = useAuth();

  if (authState?.loggedUser?.activePlan) {
    return null;
  }

  return (
    <div className="bg-[#FF624266] rounded-[10px] p-5">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-2.5 md:gap-4">
        <div className="flex flex-col gap-1">
          <h3 className="text-[#FFF] font-[Inter] text-[16px] not-italic font-bold leading-[20px]">
            Your Profile Isn't Visible to Brands
          </h3>
          <p className="text-[#ADADAD] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
            Activate your profile to start showing up in brand searches and
            receive collaboration opportunities
          </p>
        </div>
        <Button
          variant="secondary"
          className="w-full sm:w-auto"
          onClick={() => {
            mixpanel.track("Activate Profile");
            navigate("/influencer/payment");
          }}
        >
          Activate Now
        </Button>
      </div>
    </div>
  );
};

export const NoticeCard = () => {
  return (
    <div className="mb-6 rounded-lg border-l-4 border border-amber-500 bg-gradient-to-r from-amber-950/50 to-amber-900/20 p-4 text-amber-100 shadow-lg">
      <div className="flex items-start">
        <div className="mr-4 mt-0.5 bg-amber-500/20 p-1.5 rounded-full">
          <AlertTriangle className="h-5 w-5 text-amber-400" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm md:text-base font-semibold text-amber-200 flex items-center">
            <span>Important Note</span>
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-amber-400 ml-2 animate-pulse"></span>
          </h3>
          <div className="mt-1.5 text-xs md:text-sm leading-relaxed">
            If any information you've entered is incorrect or incomplete, your
            profile may not be visible to brands. Please make sure all details
            are accurate and up to date.
          </div>
        </div>
      </div>
    </div>
  );
};

export const FeaturedCard = () => {
  return (
    <div className="rounded-lg border border-[#C77398]/30 bg-gradient-to-r from-[#C77398]/20 to-[#A25A7C]/20 p-4 md:p-6 relative overflow-hidden h-auto">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-32 md:w-64 h-32 md:h-64 bg-[#C77398]/5 rounded-full -mr-16 md:-mr-32 -mt-16 md:-mt-32"></div>
      <div className="absolute bottom-0 left-0 w-20 md:w-40 h-20 md:h-40 bg-[#C77398]/5 rounded-full -ml-10 md:-ml-20 -mb-10 md:-mb-20"></div>

      <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 md:gap-6 relative z-10">
        {/* Icon - centered on mobile */}
        <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#D98CAD] to-[#C77398] rounded-full shadow-lg">
          <Trophy className="h-6 w-6 md:h-8 md:w-8 text-white" />
        </div>

        {/* Content - full width on mobile */}
        <div className="flex-1 text-center sm:text-left">
          <div className="mb-1">
            <h3 className="text-lg md:text-xl font-bold text-white">
              Congratulations!
            </h3>
          </div>
          <p className="text-base md:text-lg text-white mb-2">
            You are a featured creator
          </p>
          <p className="text-xs md:text-sm text-gray-100/90 mb-3">
            Your exceptional content and consistency have earned you a place on
            our leaderboard. Keep creating and inspiring!
          </p>

          {/* Top 10% badge - appears at the top on mobile */}
          {/* <div className="sm:hidden mb-4 flex justify-center">
            <div className="flex items-center gap-1.5 bg-[#C77398]/30 rounded-full px-3 py-1">
              <Crown className="h-4 w-4 text-white" />
              <span className="text-sm font-medium text-white">Top 10%</span>
            </div>
          </div> */}

          {/* Achievement badges - centered on mobile */}
          <div className="flex flex-wrap justify-center sm:justify-start gap-2">
            <div className="flex items-center gap-1.5 bg-[#C77398]/20 rounded-full px-2 sm:px-3 py-1 sm:py-1.5">
              <Award className="h-3 w-3 md:h-4 md:w-4 text-white" />
              <span className="text-xs font-medium text-white">
                High Engagement
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-[#C77398]/20 rounded-full px-2 sm:px-3 py-1 sm:py-1.5">
              <Award className="h-3 w-3 md:h-4 md:w-4 text-white" />
              <span className="text-xs font-medium text-white">
                Quality Content
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-[#C77398]/20 rounded-full px-2 sm:px-3 py-1 sm:py-1.5">
              <Award className="h-3 w-3 md:h-4 md:w-4 text-white" />
              <span className="text-xs font-medium text-white">
                Brand Favorite
              </span>
            </div>
          </div>
        </div>

        {/* Top 10% badge - shown on the right for larger screens */}
        {/* <div className="hidden sm:block flex-shrink-0">
          <div className="flex items-center gap-1.5 bg-[#C77398]/30 rounded-full px-3 py-1">
            <Crown className="h-4 w-4 text-white" />
            <span className="text-sm font-medium text-white">Top 10%</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export const ToolsCards = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <FreeToolsExplorerCard />
      <AnalyticsExplorerCard />
      <BoostVisibilityCard />
    </div>
  );
};

export const FreeToolsExplorerCard = () => {
  const navigate = useNavigate();
  const staticDataState = useStaticData();
  const [allToolList, setALLToolList] = useState([]);
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    async function getCreatorTools() {
      const result = await staticDataState?.getNewDataFromType("Creator Tools");
      setALLToolList(result || []);
    }
    getCreatorTools();
  }, [staticDataState]);

  // Auto-scroll effect
  useEffect(() => {
    if (!allToolList.length || isDragging) return;

    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationFrameId;
    const speed = 0.5; // pixels per frame

    const scroll = () => {
      if (scrollContainer) {
        scrollContainer.scrollLeft += speed;

        // Reset scroll position when reaching the end
        if (
          scrollContainer.scrollLeft >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft = 0;
        }
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [allToolList, isDragging]);

  // Mouse drag handlers for manual scrolling
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.pageX - scrollRef.current.offsetLeft;
    const distance = x - startX;
    scrollRef.current.scrollLeft = scrollLeft - distance;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };
  return (
    <div className="flex flex-col items-start justify-between gap-3 flex-1 self-stretch p-5 bg-[#1E2430] rounded-lg font-inter">
      <div className="flex flex-col items-start gap-3">
        {/* Exclusive Access Badge */}
        <div className="flex justify-center items-center gap-2 rounded border border-[#2D3748] bg-[#2D3748] px-4 py-1">
          <span className="text-white text-center text-xs font-semibold">
            EXCLUSIVE ACCESS
          </span>
          <span>
            <Search color="#3B82F6" size={16} />
          </span>
        </div>

        {/* Title with Tool Icon */}
        <div className="flex items-center gap-2.5 self-start">
          <span>
            <Wrench size={24} color="#2D9CDB" />
          </span>
          <h3 className="text-white text-lg font-bold">Explore Free Tools</h3>
        </div>

        {/* Description */}
        <p className="text-[#A0AEC0] text-xs leading-5">
          Boost your LinkedIn presence with our collection of free tools built
          for creators. Optimize your content and track your growth
          effortlessly.
        </p>
      </div>

      {/* Infinite Scrolling Tools Container */}
      <div className="w-full mt-2 mb-3 overflow-hidden">
        <div
          ref={scrollRef}
          className="flex gap-4 py-2 overflow-x-auto scrollbar-hide cursor-grab active:cursor-grabbing"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
        >
          {/* Duplicate tools list for seamless infinite scroll effect */}
          {allToolList.length > 0 && (
            <>
              {allToolList.map((tool, index) => (
                <div
                  key={`tool-${index}`}
                  className="flex flex-col items-center flex-shrink-0"
                >
                  <div className="w-16 h-16 bg-[#1A202C] rounded-md flex items-center justify-center">
                    <img
                      src={
                        tool?.toolIcon ??
                        `https://logo.clearbit.com/:${tool?.toolWebsite}`
                      }
                      alt={tool?.toolName}
                      className="w-8 h-8"
                    />
                  </div>
                  {/* <span className="text-[#A0AEC0] text-xs mt-2 text-center">
                    {tool?.toolName}
                  </span> */}
                </div>
              ))}

              {/* Duplicate elements to create illusion of infinite loop */}
              {allToolList.map((tool, index) => (
                <div
                  key={`tool-dup-${index}`}
                  className="flex flex-col items-center flex-shrink-0"
                >
                  <div className="w-16 h-16 bg-[#1A202C] rounded-md flex items-center justify-center">
                    <img
                      src={
                        tool?.toolIcon ??
                        `https://logo.clearbit.com/:${tool?.toolWebsite}`
                      }
                      alt={tool?.toolName}
                      className="w-8 h-8"
                      onError={(e: any) => {
                        if (
                          e.target.src !== `${tool?.toolWebsite}favicon.ico`
                        ) {
                          e.target.onerror = null;
                          e.target.src = `${tool?.toolWebsite}favicon.ico`;
                        }
                      }}
                    />
                  </div>
                  {/* <span className="text-[#A0AEC0] text-xs mt-2 text-center">
                    {tool?.toolName}
                  </span> */}
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      {/* Explore Button */}
      <Button
        onClick={() => {
          navigate("/influencer/tools");
        }}
        className="bg-white text-[#121212] w-full py-2 text-sm font-semibold rounded-md hover:bg-gray-100 transition-colors"
        variant="outline"
      >
        Explore All Tools
      </Button>
    </div>
  );
};

export const AnalyticsExplorerCard = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-start justify-between gap-3 flex-[1_0_0] self-stretch p-5 bg-[#1E2430] rounded-[10px] font-inter">
      <div className="flex flex-col items-start gap-3">
        <div className="flex justify-center items-center gap-2 rounded border border-[#2D3748] bg-[#2D3748] px-4 py-1">
          <span className="text-[#FFFFFF] text-center text-xs font-semibold">
            PERFORMANCE INSIGHTS
          </span>
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
                fill="#4299E1"
              />
              <path
                d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                fill="#4299E1"
              />
            </svg>
          </span>
        </div>

        {/* Title with Analytics Icon */}
        <div className="flex items-center gap-2.5 self-start">
          <BarChartIcon className="text-[#4299E1]" size={22} />

          <h3 className="text-white text-lg font-bold">Profile Analytics</h3>
        </div>

        {/* Description */}
        <p className="text-[#A0AEC0] text-xs leading-5">
          Track your profile performance with detailed analytics. See what’s
          working, monitor your daily progress, brand connections, and earnings.
        </p>
      </div>
      {/* Analytics Badge */}

      {/* Analytics Preview */}
      <div className="w-full  rounded-md p-3">
        <div className="flex justify-between">
          <div className="flex flex-col items-center bg-[#1A202C] rounded-md w-1/3 p-3 mr-2">
            <div className="text-[#4299E1] text-xl font-bold">👩🏻‍🤝‍👩🏼</div>
            <div className="text-white text-xs font-medium mt-1">Referrals</div>
          </div>
          <div className="flex flex-col items-center bg-[#1A202C] rounded-md w-1/3 p-3 mr-2">
            <div className="text-[#4299E1] text-xl font-bold">💰</div>
            <div className="text-white text-xs font-medium mt-1">Revenue</div>
          </div>
          <div className="flex flex-col items-center bg-[#1A202C] rounded-md w-1/3 p-3">
            <div className="text-[#4299E1] text-xl font-bold">🫱🏼‍🫲🏽</div>
            <div className="text-white text-xs font-medium mt-1">Brands</div>
          </div>
        </div>
      </div>

      {/* Explore Button */}
      <Button
        onClick={() => {
          navigate("/influencer/analytics");
        }}
        className="bg-white text-[#121212] w-full py-2 text-sm font-semibold rounded-md hover:bg-gray-100 transition-colors"
        variant="outline"
      >
        View Analytics Dashboard
      </Button>
    </div>
  );
};

// Boost Visibility Card Component
export const BoostVisibilityCard = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-start justify-between gap-3 flex-[1_0_0] self-stretch p-5 bg-[#1E2430] rounded-[10px] font-inter">
      {/* Visibility Badge */}
      <div className="flex flex-col items-start gap-3">
        <div className="flex justify-center items-center gap-2 rounded border border-[#2D3748] bg-[#2D3748] px-4 py-1">
          <span className="text-[#FFFFFF] text-center text-xs font-semibold">
            GROW YOUR REACH
          </span>
          <Code2 className="text-[#F6AD55]" size={14} />
        </div>

        {/* Title with Visibility Icon */}
        <div className="flex items-center gap-2.5 self-start">
          <span>
            <Search className="text-[#F6AD55]" size={22} />
          </span>
          <h3 className="text-white text-lg font-bold">Boost Visibility</h3>
        </div>

        {/* Description */}
        <p className="text-[#A0AEC0] text-xs leading-5">
          Discover creative ways to boost your profile visibility and attract
          more brand collaborations.
        </p>
      </div>

      {/* Visibility Features */}
      <div className="w-full mt-2 mb-3">
        <div className="flex justify-between">
          <div className="flex flex-col items-center bg-[#1A202C] p-3 rounded-md w-1/3 mr-2">
            <div className="text-[#F6AD55] text-lg mb-1">🔗</div>
            <div className="text-white text-xs font-medium text-center">
              Share
            </div>
          </div>
          <div className="flex flex-col items-center bg-[#1A202C] p-3 rounded-md w-1/3 mr-2">
            <div className="text-[#F6AD55] text-lg mb-1">📣</div>
            <div className="text-white text-xs font-medium text-center">
              Announce
            </div>
          </div>
          <div className="flex flex-col items-center bg-[#1A202C] p-3 rounded-md w-1/3">
            <div className="text-[#F6AD55] text-lg mb-1">👥</div>
            <div className="text-white text-xs font-medium text-center">
              Earn
            </div>
          </div>
        </div>
      </div>

      {/* Explore Button */}
      <Button
        onClick={() => {
          navigate("/influencer/boostVisibility");
        }}
        className="bg-white text-[#121212] w-full py-2 text-sm font-semibold rounded-md hover:bg-gray-100 transition-colors"
        variant="outline"
      >
        Explore Growth Strategies
      </Button>
    </div>
  );
};
